<ng-container
  cdkStepper
  #stepper="cdkStepper"
  selectedIndex="0"
  orientation="horizontal"
>
  <cdk-step label="Content" i18n-label="@@ip_aside_stepper:Content">
    <h1 tailH2 i18n="@@blocks_list">Blocks</h1>
    <div
      class="grid gap-2 grid-cols-2"
      cdkDropList
      [cdkDropListConnectedTo]="columnsDropLists"
      [cdkDropListSortingDisabled]="true"
    >
      <ng-container
        *ngFor="let block of [blocks] | applyMiddleware : 'blocksList' | async"
      >
        <div
          class="border rounded border-gray-200 bg-white text-xs uppercase text-center py-4 px-2 cursor-move select-none"
          cdkDrag
          [cdkDragData]="block | toBodyBlock"
        >
          {{ block.title }}
        </div>
      </ng-container>
    </div>
    <h1 tailH2 i18n="@@structude_list" class="uppercase">Structures</h1>
    <div
      class="grid gap-2 grid-cols-2"
      cdkDropList
      [cdkDropListConnectedTo]="structuresDropLists"
      [cdkDropListSortingDisabled]="true"
      (cdkDropListDropped)="onDrop($event)"
    >
      <ng-container
        *ngFor="
          let structure of [structures]
            | applyMiddleware : 'structuresList'
            | async
        "
      >
        <div
          class="border rounded border-gray-200 bg-white cursor-move select-none flex gap-2 p-2"
          cdkDrag
          [cdkDragData]="structure | toBodyStructure"
        >
          <div
            *ngFor="let col of structure.options.columns; let index = index"
            class="bg-gray-200 h-9 rounded"
            [ngClass]="{
              'w-1/3 flex-shrink-0':
                (structure.type === 'cols_21' && index === 0) ||
                (structure.type === 'cols_12' && index === 1),
              'w-full': !(
                (structure.type === 'cols_21' && index === 0) ||
                (structure.type === 'cols_12' && index === 1)
              )
            }"
          ></div>
        </div>
      </ng-container>
    </div>
    <h1 tailH2 i18n="@@structude_list" class="uppercase">Snippets</h1>
    <div class="wrapper">
      <div
        class="{{ snippetList?.length == 0 ? '' : 'grid gap-2 grid-cols-2' }}"
      >
        <ng-container *ngFor="let item of snippetList">
          <div
            class="border rounded border-gray-200 bg-white text-sm uppercase text-center p-3 cursor-move select-none snippet text-break"
            draggable="true"
            (dragstart)="onDragStart($event, item?.title)"
          >
            {{ item?.title }}
            <div class="snippet-copy-btn">
              <button class="tool-button" (click)="copy(item?.title)">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-3 w-3"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    d="M7 9a2 2 0 012-2h6a2 2 0 012 2v6a2 2 0 01-2 2H9a2 2 0 01-2-2V9z"
                  />
                  <path
                    d="M5 3a2 2 0 00-2 2v6a2 2 0 002 2V5h8a2 2 0 00-2-2H5z"
                  />
                </svg>
              </button>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="snippetList?.length == 0">
          <p class="text-center">No Snippets Available</p>
        </ng-container>
      </div>
    </div>
    <div class="pagination-control pagination-center mt-2">
      <ngb-pagination
        #ngbPage
        [boundaryLinks]="false"
        [collectionSize]="totalRecords"
        [pageSize]="pageSize"
        [page]="page"
        [maxSize]="6"
        (pageChange)="onPageChanged($event)"
      >
        <ng-template ngbPaginationPrevious>&#8810;</ng-template>
        <ng-template ngbPaginationNext>&#8811;</ng-template>
      </ngb-pagination>
    </div>
  </cdk-step>
  <!-- <cdk-step label="Modules" i18n-label="@@ip_aside_stepper:Modules">
    <div class="grid gap-2 grid-cols-2" cdkDropList [cdkDropListConnectedTo]="customColumnsDropLists"
    [cdkDropListSortingDisabled]="true">
    <ng-container *ngFor="let block of [customBlocks] | applyMiddleware: 'blocksList' | async">
      <button class="border rounded border-gray-200 bg-white text-sm uppercase text-center p-4 cursor-move select-none"
      cdkDrag [cdkDragData]="block | toBodyBlock" >
        {{ block.title}}
      </button>
    </ng-container>
    </div>
  </cdk-step> -->
  <cdk-step label="Modules" i18n-label="@@ip_aside_stepper:Modules">
    <div
      class="wrapper mt-2"
      cdkDropList
      [cdkDropListConnectedTo]="customColumnsDropLists"
      [cdkDropListSortingDisabled]="true"
    >
      <!-- <ng-container *ngFor="let block of customBlocks">
        <button 
          class="m-1 rounded border-gray-200 bg-white text-sm uppercase text-center p-2 cursor-move select-none"
          cdkDrag
          [cdkDragData]="block"  
          (click)="handleButtonClick(block)"
        >
          {{ block.title }}
        </button>
      </ng-container> -->
      <!-- <div class="d-flex flex-wrap"> 
      <div *ngFor="let item of snippetList"  class="draggable-item m-1 rounded border-gray-200 bg-white text-sm uppercase text-center p-2 cursor-move select-none" draggable="true" (dragstart)="onDragStart($event,item)">
        {{item}}
      </div>
    </div> -->
    </div>
  </cdk-step>

  <cdk-step label="Settings" i18n-label="@@ip_aside_stepper:Settings">
    <ng-container [cdkPortalOutlet]="currentSettings$ | async"></ng-container>
  </cdk-step>
</ng-container>

<div
  class="stepper grid grid-cols-3 border divide-x divide-gray-200"
  role="tablist"
>
  <ng-container *ngFor="let step of stepper.steps">
    <button
      (click)="step.select()"
      class="step bg-white py-4 uppercase text-sm transition-colors font-normal select-none text-gray-800 border-b shadow-sm"
      [class.active]="step === stepper.selected"
      role="tab"
      [attr.aria-selected]="step === stepper.selected"
    >
      <b>{{ step.label }}</b>
    </button>
  </ng-container>
</div>

<div
  class="px-2 flex-1 max-h-full overflow-x-auto pb-10 sidebar"
  role="tabpanel"
  [attr.aria-expanded]="!!stepper.selected"
>
  <ng-container
    [ngTemplateOutlet]="stepper.selected ? stepper.selected.content : null"
  ></ng-container>
</div>

<div class="absolute inset-0 bg-white opacity-80" *ngIf="readonly"></div>
